<template>
    <div class="myFooter">
        <!-- 第一层 -->
        <div class="cont1">
            <div class="item1 dis">
                <div @click="seturl(i)" v-for="(p,i) in titleArr">{{p}}</div>
            </div>
            <div class="item2 disbtn">
                <div class="item2Cont1 dis">
                    <img :src="obj.logo" alt="">
                    <!-- <div class="item2Cont2">服务热线：{{obj.m_400}}</div> -->
					<div class="item2Cont2">
						<span style="font-size: 32px;font-weight: 600;">"仪表天下"濮阳运营中心</span><br>
						<span style="font-size: 16px;">电话: 0393-6909111、6909222、6909333</span><br>
						<span style="font-size: 16px;">地址: 濮阳经开区中原路西段安凯路 国家级科技企业孵化器</span>
					</div>
                </div>
                <div class="item2Cont3">
                    <div class="divimg">
                        <img :src="obj.ewm2" alt="">
                    </div>
                    <div>微信小程序</div>
                </div>
            </div>
        </div>
        <!-- 第二层 -->
        <div class="cont2">
            <div>Copyright © 2010-2025   861718.com    All rights reserved 版权所有 　©君和数字创意</div>
            <!-- <div>本站转载或引用文章涉及版权问题请与我们联系。电话：15890626732 </div> -->
			<div>本站转载或引用文章涉及版权问题请与我们联系。电话：0393-6909333 </div>
            <div>网站备案/许可证：豫ICP备20007315号     Copyright © 2020-2025君和数字创意 All rights reserved     技术支持：君和数字创意</div>
        </div>
    </div>
</template>

<script>
export default {
    props:['obj'],
    data() {
        return {
            //titleArr:['仪表天下首页','行业资讯','专业服务','仪表商城','品牌供应商','用户协议','隐私协议'],
			titleArr:['仪表天下首页','知识与经验','仪表产品','专业服务','行业资讯','用户协议','隐私协议'],
            // obj:'',
        };
    },

    mounted() {
        
    },

    methods: {
        // 跳转
        // seturl(num){
        //     let src=''
        //     if( num == 0){src='/'}
        //     if( num == 1){src='/about'}
        //     if( num == 2){src='/serve'}
        //     if( num == 3){src='/facility'}
        //     if( num == 4){src='/supplier'}
        //     if( num == 5){src='/touch1'}
        //     if( num == 6){src='/touch2'}
        //     this.$router.push(src)
        // },
		seturl(num){
		    let src=''
		    if( num == 0){src='/'}
		    if( num == 1){src='/about?type=1'}
		    if( num == 3){src='/serve'}
		    if( num == 2){src='/facility'}
			 if( num == 4){src='/about'}
		    if( num == 5){src='/touch1'}
		    if( num == 6){src='/touch2'}
		    this.$router.push(src)
		},
    },
};
</script>

<style lang="less" scoped>
.myFooter{
    font-family: Microsoft YaHei;
    color: #FFFFFF;
    background: #333333;
    margin: 0 auto;
    // height: 359px;
    .dis{
        display: flex;
        align-items: center;
    }
    .disbtn{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .cont1{
        padding-bottom: 24px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        .item1{
            width: 1200px;
            margin: 0 auto;
            padding-left: 1px;
            padding-top: 31px;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
            :hover{
                color: #E1251B;
            }
            &>div:not(:last-child):after{
                content: '|';
                color: #fff;
                margin: 0 20px;
            }
        }
        .item2{
            width: 1200px;
            margin: 0 auto;
            margin-top: 8px;
            .item2Cont1{
                img{
                  width: 112px;
                //   height: 70px;  
                }
                .item2Cont2{
                    font-size: 24px;
                    font-weight: 400;
                    margin-left: 62px;
                }
            }
            .item2Cont3{
                font-size: 14px;
                font-weight: 400;
                text-align: center;
                img{
                    width: 105px;
                    height: 112px;
                    margin-bottom: 12px;
                }
            }
        }
    }
    .cont2{
        padding: 37px 0;
        width: 1200px;
        text-align: center;
        margin: 0 auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 28px;
        opacity: 0.8;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/head_foot/myFooter.vue